import { HotelDailyServiceInfo, HotelRoomInfo } from "@donstudio/shared/api/models";
import { createAction, props } from "@ngrx/store";

export const RoomRowClicked = createAction(
    '[room component] row room clicked',
    props<{ roomData: HotelRoomInfo | null }>()
);

export const DailyServicePriceClicked = createAction(
    '[daily service price component] daily service price clicked',
    props<{ daily: HotelDailyServiceInfo[] | null }>()
);

export const ReplaceRoomRowClicked = createAction(
    '[replace room component] row room clicked',
    props<{ replaceRoomData: HotelRoomInfo | null }>()
);

export const isChangedData = createAction(
    '[My Feature] Update Boolean Value',
    props<{ newValue: boolean }>()
);